import { TEST_SETS_COUNT_LIMIT } from "../constants";
import { SheetSelection } from "./components/SheetsSelection";

export function SingleSheetSelection({
  sheetIds = [],
  setFieldValue,
  fieldName,
  fieldCount,
  fieldLabels,
  sheetData,
  ...rest
}) {
  const handleChange = (e, index) => {
    const newSheetIds = [...sheetIds];
    newSheetIds[index] = e.target.value;
    setFieldValue(fieldName, newSheetIds);
  };

  return (
    <SheetSelection
      sheetIds={sheetIds}
      sheetData={sheetData}
      fieldName={fieldName}
      fieldLabels={fieldLabels}
      fieldCount={fieldCount || TEST_SETS_COUNT_LIMIT}
      onChange={handleChange}
      {...rest}
    />
  );
}
